// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__wlz_j","addWidgetButton":"Header_addWidgetButton__1yisC","dashboardTabs":"Header_dashboardTabs__2o00v","active":"Header_active__STu_n"};